export default __webpack_public_path__ + "static/checknotflat-7704f2df3dd213f56ae96c264b166752.png";